import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import RoomRequisitionCancellationApprovalForm from "../../forms/RoomReq/RoomRequisitionCancellationApprovalForm";
import {
  getCancelledRoomRequisitions,
  approveCancelledRoomRequisitions,
  rejectCancelledRoomRequisitions,
} from "../../../api/roomRequisitionApprovalApi";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

export default function RoomRequisitionCancellationApprovalPage({ history }) {
  const location = useLocation();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [roomRequisitions, setRoomRequisitions] = useState([]);
  const [selectedRoomRequisitions, setSelectedRoomRequisitions] = useState([]);
  const [currentYear, setCurrentYear] = useState(
    location.state ? location.state.year : dayjs().year()
  );
  const [pagination, setPagination] = useState({
    current: 1,
    minIndex: 0,
    maxIndex: 100,
    pageSize: 100,
  });

  useEffect(getRoomRequisitions, [currentYear]);

  function getRoomRequisitions() {
    setIsLoading(true);
    getCancelledRoomRequisitions(currentYear)
      .then((value) => {
        // reset pagination
        resetPagination();

        setRoomRequisitions(value ? value : []);
        setSelectedRoomRequisitions([]);
        setIsLoading(false);
      })
      .catch((error) => {
        showErrorMessage(t("general.fail_to_load_record"), error);
      });
  }

  function resetPagination() {
    setPagination({
      current: 1,
      minIndex: 0,
      maxIndex: 100,
      pageSize: 100,
    });
  }

  function onAddNewRoomRequisition() {
    history("/home/meetingroomrequisition/roomtrans");
  }

  function onApproveRoomRequisitions(selectedRoomRequisitions) {
    setIsLoading(true);

    approveCancelledRoomRequisitions(selectedRoomRequisitions)
      .then(() => {
        getRoomRequisitions();
        toast.success(t("general.record_approved_successfully"));
      })
      .catch((error) => {
        setIsLoading(false);
        showErrorMessage(t("general.fail_to_approve_record"), error);
      });
  }

  function onRejectRoomRequisitions(selectedRoomRequisitions, reason) {
    setIsLoading(true);

    rejectCancelledRoomRequisitions(selectedRoomRequisitions, reason)
      .then(() => {
        getRoomRequisitions();
        toast.success(t("general.record_rejected_successfully"));
      })
      .catch((error) => {
        setIsLoading(false);
        showErrorMessage(t("general.fail_to_reject_record"), error);
      });
  }

  function viewRoomRequisitions(roomRequisitionKey) {
    history("/home/meetingroomrequisition/roomtrans/" + roomRequisitionKey, {
      state: { fromCancel: true },
    });
  }

  function showErrorMessage(message, error) {
    let errorMsg = error.response.data.error_description
      ? error.response.data.error_description
      : error.response.data.ExceptionMessage;

    toast.error(message + (errorMsg ? errorMsg : ""));
  }

  return (
    <RoomRequisitionCancellationApprovalForm
      isLoading={isLoading}
      data={roomRequisitions}
      selectedItems={selectedRoomRequisitions}
      onAdd={onAddNewRoomRequisition}
      onView={viewRoomRequisitions}
      onApproved={onApproveRoomRequisitions}
      onRejected={onRejectRoomRequisitions}
      onItemSelected={setSelectedRoomRequisitions}
      setCurrentYear={setCurrentYear}
      currentYear={currentYear}
      pagination={pagination}
      setPagination={setPagination}
      resetPagination={resetPagination}
    />
  );
}

RoomRequisitionCancellationApprovalPage.propTypes = {
  history: PropTypes.func.isRequired,
};
